import {takeEvery, throttle, all} from "redux-saga/effects";
import getAirportData from "./airportSaga";
import getInterlineOperatorsData from "./interlineOperatorsSaga";
import getScheduleData from "./scheduleSaga";
import getServiceLevelData from "./serviceLevelSaga";
import getServiceLevelProductsData from "./serviceLevelProductsSaga";
import getServiceLevelSpecialtiesData from "./serviceLevelSpecialtiesSaga";
import getShipmentData from "./shipmentSaga"
import getShipmentDetailsData from "./shipmentDetailsSaga";
import getFacilitiesData from "./facilitiesSaga";
import getHolidayHoursData from "./holidayHoursSaga";
import getFacilitiesMetaData from "./facilitiesMetaSaga";
import getFormsData from "./formsSaga";
import getNewsData from "./newsSaga";
import getCustomerTestimonialsData from "./customerTestimonialsSaga";
import getAwardsData from "./awardsSaga";
import getPressReleasesData from "./pressReleasesSaga";
import getShipmentByAccountNUmber from "./shipmentByAccountNumberSaga";
import getCarouselData from "./carouselSaga";
import getShippingAdvisoryData from "./shippingAdvisorySaga";
import getTrainingVideosData from "./trainingVideosSaga";
import getScanStatusData from "./scanStatusSaga";
import getScanDetailsData from "./scanDetailsSaga";
import getSitemapData from "./sitemapSaga";
import getNonRevAndRevFacilitiesData from "./nonRevAndRevFacilitiesSaga";
import {REQUEST_SERVICELEVEL_DATA} from "../actions/serviceLevelDataActions";
import {REQUEST_SERVICE_LEVEL_PRODUCTS_DATA} from "../actions/serviceLevelProductsActions";
import {REQUEST_SERVICE_LEVEL_SPECIALTIES_DATA} from "../actions/serviceLevelSpecialtiesActions";
import {REQUEST_AIRPORT_DATA} from "../actions/airportDataActions";
import {REQUEST_SHIPMENT_DATA} from "../actions/shipmentDataActions";
import {REQUEST_SHIPMENT_DETAILS_DATA} from "../actions/shipmentDetailsDataActions";
import {REQUEST_FACILITIES_DATA, REQUEST_HOLIDAY_HOURS_DATA} from "../actions/facilitiesActions";
import {REQUEST_FACILITIES_META_DATA} from "../actions/facilitiesMetaActions";
import {REQUEST_FORMS_DATA} from "../actions/formsActions";
import {REQUEST_SCHEDULE_DATA} from "../actions/schedulesDataActions";
import {REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER} from "../actions/shipmentDataByAccountNumberActions";
import {REQUEST_CUSTOMER_TESTIMONIALS_DATA} from "../actions/customerTestimonialsActions";
import {REQUEST_NEWS_DATA} from "../actions/newsActions";
import {REQUEST_AWARDS_DATA} from "../actions/awardsActions";
import {REQUEST_INTERLINE_OPERATORS} from "../actions/interlineOperatorsActions";
import {REQUEST_PRESS_RELEASES_DATA} from "../actions/pressReleasesActions";
import {REQUEST_CAROUSEL_DATA} from "../actions/carouseActions";
import {REQUEST_SHIPPING_ADVISORY_DATA} from "../actions/shippingAdvisoryActions";
import {REQUEST_TRAINING_VIDEOS_DATA} from "../actions/trainingVideosActions";
import { REQUEST_SCAN_STATUS_DATA } from "../actions/scanStatusDataActions";
import {REQUEST_SCAN_DETAILS_DATA} from "../actions/scanDetailsDataActions";
import {REQUEST_SITEMAP_DATA} from "../actions/sitemapActions";
import {REQUEST_NON_REV_AND_REV_FACILITIES_DATA} from "../actions/nonRevAndRevFacilitiesActions";


function* fetchDataWatcher() {
  yield takeEvery(REQUEST_AIRPORT_DATA, getAirportData);
  yield throttle(1000, REQUEST_SCHEDULE_DATA, getScheduleData);
  yield takeEvery(REQUEST_SERVICELEVEL_DATA, getServiceLevelData);
  yield takeEvery(REQUEST_SERVICE_LEVEL_PRODUCTS_DATA, getServiceLevelProductsData);
  yield takeEvery(REQUEST_SERVICE_LEVEL_SPECIALTIES_DATA, getServiceLevelSpecialtiesData);
  yield takeEvery(REQUEST_SHIPMENT_DATA, getShipmentData);
  yield takeEvery(REQUEST_SHIPMENT_DETAILS_DATA, getShipmentDetailsData);
  yield takeEvery(REQUEST_FACILITIES_DATA, getFacilitiesData);
  yield takeEvery(REQUEST_NON_REV_AND_REV_FACILITIES_DATA, getNonRevAndRevFacilitiesData)
  yield takeEvery(REQUEST_HOLIDAY_HOURS_DATA, getHolidayHoursData);
  yield takeEvery(REQUEST_FACILITIES_META_DATA, getFacilitiesMetaData);
  yield takeEvery(REQUEST_FORMS_DATA, getFormsData);
  yield takeEvery(REQUEST_NEWS_DATA, getNewsData);
  yield takeEvery(REQUEST_CUSTOMER_TESTIMONIALS_DATA, getCustomerTestimonialsData);
  yield takeEvery(REQUEST_AWARDS_DATA, getAwardsData);
  yield takeEvery(REQUEST_INTERLINE_OPERATORS, getInterlineOperatorsData);
  yield takeEvery(REQUEST_PRESS_RELEASES_DATA, getPressReleasesData);
  yield takeEvery(REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER, getShipmentByAccountNUmber);
  yield takeEvery(REQUEST_CAROUSEL_DATA, getCarouselData);
  yield takeEvery(REQUEST_SHIPPING_ADVISORY_DATA, getShippingAdvisoryData);
  yield takeEvery(REQUEST_TRAINING_VIDEOS_DATA, getTrainingVideosData);
  yield takeEvery(REQUEST_SCAN_STATUS_DATA, getScanStatusData);
  yield takeEvery(REQUEST_SCAN_DETAILS_DATA, getScanDetailsData);
  yield takeEvery(REQUEST_SITEMAP_DATA, getSitemapData);
}

export default function* rootSaga() {
  yield all([
    fetchDataWatcher()
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js